import { combineReducers } from "redux";
import SESSION_VARIABLES from "./sessionReducer";

export default combineReducers({
  session: SESSION_VARIABLES,
});
